import { useEffect, useState } from 'react'

// local imports
import { INotRatedReservations } from 'types/RateType'
import RateService from 'service/RateService'

export default function useGetNotRatedReservations() {
  const [list, setList] = useState<INotRatedReservations[] | []>([])
  const [loading, setLoading] = useState(false)

  /* Get Not Rated Reservation List */
  const getReservationList = (showLoading = false) => {
    if (showLoading) setLoading(true)
    RateService.getNotRatedReservationsList()
      .then((r) => setList(r.data))
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }

  useEffect(() => getReservationList(true), [])

  return { list, getReservationList, loading }
}
